import { requester } from '@space-shell/config/request'

import { GlobalSearchEndpoints, MAX_RESULTS_PER_PAGE } from './constants'
import type {
  GetGlobalFindParams,
  GetGlobalSearchParams,
  GlobalSearchResult,
  SearchResult
} from './types'

class GlobalSearchService {
  static putGlobalHierarchy = async (membershipSlug: string) => {
    const response = await requester.put(GlobalSearchEndpoints.hierarchy(membershipSlug))

    return response.data
  }

  static getGlobalFind = async ({
    membershipSlug,
    term,
    size = MAX_RESULTS_PER_PAGE,
    searchAfter
  }: GetGlobalFindParams) => {
    const { data } = await requester.get<SearchResult>(GlobalSearchEndpoints.find(membershipSlug), {
      params: {
        term,
        size,
        searchAfter
      }
    })

    return data
  }

  static getGlobalSearch = async ({
    language,
    membershipSlug,
    term,
    size
  }: GetGlobalSearchParams) => {
    const { data } = await requester.get<GlobalSearchResult>(
      GlobalSearchEndpoints.search(membershipSlug),
      {
        params: {
          term,
          language,
          size
        }
      }
    )

    return data
  }
}

export default GlobalSearchService
